import { useReadFilesAsBase64 } from 'components/FilesSelector/hooks/useReadFilesAsBase64';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uploadPriceListUerMutation } from './uerQueries';

export const useUploadPriceListUer = (contractId?: number) => {
    const dispatch = useDispatch();

    const [priceListCollectionReset] = useResetStoreData({ requestId: 'uploadPriceListUerMutation' });

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [files, setFiles] = useState<File[]>([]);

    const base64Files = useReadFilesAsBase64(files);

    const [uploadPriceListUerData, uploadPriceListUerStatus, uploadPriceListUerError, uploadPriceListUerMakeRequest] =
        useRequest({
            requestId: 'uploadPriceListUerMutation',
            query: uploadPriceListUerMutation,
            withEffect: false,
        });

    useEffect(
        () => () => {
            priceListCollectionReset(undefined);
        },
        [priceListCollectionReset],
    );

    useEffect(() => {
        if (files?.length && base64Files?.length && !uploadPriceListUerData?.uerImportPriceListCollection) {
            dispatch(
                uploadPriceListUerMakeRequest({
                    contractId,
                    fileContent: base64Files[0],
                }),
            );

            setIsSubmitted(true);
            setFiles([]);
        }
    }, [
        base64Files,
        base64Files?.length,
        contractId,
        dispatch,
        files,
        isSubmitted,
        uploadPriceListUerData?.uerImportPriceListCollection,
        uploadPriceListUerMakeRequest,
    ]);

    const makeRequestHandler = useCallback((filesToHandle) => {
        if (filesToHandle.length) {
            setFiles(filesToHandle);
        }
    }, []);

    const handleCloseModalErrorUploadPriceList = useCallback(() => {
        setIsSubmitted(false);
        priceListCollectionReset(undefined);
        setFiles([]);
    }, [priceListCollectionReset]);

    const handleCreateReportUploadPriceList = () => {
        ExportCSVReport(uploadPriceListUerData?.uerImportPriceListCollection?.validation);
    };

    return {
        isSubmitted,
        uploadPriceListUerData,
        uploadPriceListUerStatus,
        uploadPriceListUerError,
        makeRequestHandler,
        handleCloseModalErrorUploadPriceList,
        handleCreateReportUploadPriceList,
        priceListCollectionReset,
    };
};
